import React from 'react';

import { cx } from '@emotion/css';

// import Image from 'next/image';
import styles from './OurSkilledView.module.scss';

export const OurSkilledView = () => {
  return (
    <section className={cx(styles.our_skilled, styles.root)}>
      <div className={styles.container}>
        <div className={styles.skilled_manage}>
          <p className={cx(styles.skilled_heading, styles.p)}>
            Our skilled tradespeople manage work orders daily for many of{' '}
            <b className={styles.skilled_heading_b}>
              London’s top letting agents, short-let managers, and property
              management companies, consistently providing high-quality service
            </b>{' '}
            and peace of mind.
          </p>
        </div>

        <div className={styles.skilled_gallery}>
          <div className={styles.gallery_for_desk}>
            <div className={styles.image_grid}>
              <div className={styles.image_grid_row}>
                <img
                  src="/images/propertyManager/ourSkilled/skilled-image1.webp"
                  alt="Image 1"
                  className={styles.image_grid_img}
                />
                <img
                  src="/images/propertyManager/ourSkilled/skilled-image2.webp"
                  alt="Image 2"
                  className={cx(styles.image_grid_img, styles.fl_auto)}
                />
              </div>
              <div className={styles.image_grid_row}>
                <img
                  src="/images/propertyManager/ourSkilled/skilled-image3.webp"
                  alt="Image 3"
                  className={styles.image_grid_img}
                />
                <img
                  src="/images/propertyManager/ourSkilled/skilled-image4.webp"
                  alt="Image 4"
                  className={styles.image_grid_img}
                />
              </div>
              <div className={styles.image_grid_row}>
                <div className={cx(styles.image_grid_inner, styles.flex_end)}>
                  <img
                    src="/images/propertyManager/ourSkilled/skilled-image5.webp"
                    alt="Image 5"
                    className={styles.image_grid_img}
                  />
                  <img
                    src="/images/propertyManager/ourSkilled/skilled-image8.webp"
                    alt="Image 8"
                    className={styles.image_grid_img}
                  />
                </div>
                <div
                  className={cx(
                    styles.image_grid_inner,
                    styles.second_image_grid_inner,
                  )}>
                  <img
                    src="/images/propertyManager/ourSkilled/skilled-image6.webp"
                    alt="Image 6"
                    className={cx(
                      styles.image_grid_img,
                      styles.skilled_image_6,
                    )}
                  />
                  <img
                    src="/images/propertyManager/ourSkilled/skilled-image7.webp"
                    alt="Image 7"
                    className={cx(
                      styles.image_grid_img,
                      styles.skilled_image_7,
                    )}
                  />
                  <img
                    src="/images/propertyManager/ourSkilled/skilled-image9.webp"
                    alt="Image 9"
                    className={cx(
                      styles.image_grid_img,
                      styles.skilled_image_9,
                    )}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <!-- ******************* for mobile ******************* --> */}
      <div className={styles.gallery_for_mob}>
        <div className={styles.image_grid}>
          <div className={styles.marquee}>
            <MarqueeMobileImgList styles={styles} isAriaHidden={false} />
            <MarqueeMobileImgList styles={styles} isAriaHidden={true} />
          </div>
        </div>
      </div>
      {/* // <!-- ******************* for mobile ******************* --> */}
    </section>
  );
};

const MarqueeMobileImgList = ({ styles, isAriaHidden }: any) => (
  <div
    aria-hidden={isAriaHidden}
    className={cx(styles.marquee__inner, styles.image_grid_marquee__inner)}>
    <MarqueeMobileImg
      styles={styles}
      src="/images/propertyManager/ourSkilled/skilled-image1.webp"
      alt="Image 1"
    />
    <MarqueeMobileImg
      styles={styles}
      src="/images/propertyManager/ourSkilled/skilled-image2.webp"
      alt="Image 2"
    />
    <MarqueeMobileImg
      styles={styles}
      src="/images/propertyManager/ourSkilled/skilled-image3.webp"
      alt="Image 3"
    />

    <MarqueeMobileImg
      styles={styles}
      src="/images/propertyManager/ourSkilled/skilled-image4.webp"
      alt="Image 4"
    />
    <MarqueeMobileImg
      styles={styles}
      src="/images/propertyManager/ourSkilled/skilled-image5.webp"
      alt="Image 5"
    />
    <MarqueeMobileImg
      styles={styles}
      src="/images/propertyManager/ourSkilled/skilled-image8.webp"
      alt="Image 8"
    />
    <MarqueeMobileImg
      styles={styles}
      src="/images/propertyManager/ourSkilled/skilled-image6.webp"
      alt="Image 6"
    />
    <MarqueeMobileImg
      styles={styles}
      src="/images/propertyManager/ourSkilled/skilled-image7.webp"
      alt="Image 7"
    />
    <MarqueeMobileImg
      styles={styles}
      src="/images/propertyManager/ourSkilled/skilled-image9.webp"
      alt="Image 9"
    />
  </div>
);

// const MarqueeDesktopImg = ({ styles, src, alt }: any) => (

// )
const MarqueeMobileImg = ({ styles, src, alt }: any) => (
  <div
    className={cx(
      styles.mq_data,
      styles.image_grid_mq_data,
      styles.gallery_mq_data,
    )}>
    <img src={src} alt={alt} className={styles.gallery_mq_data_img} />
  </div>
);
